import React, {
  lazy, FunctionComponent, useCallback, useEffect, useState, useContext
} from 'react';
import { ListItemIcon, MenuItem, Theme, Box, Button, Link as MuiLink } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Language } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { Link, Route, Switch, useHistory, Redirect, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CacheRoute, { CacheSwitch } from 'react-router-cache-route';
import copy from 'copy-to-clipboard';
import { filter } from 'lodash';
import _ from 'lodash';
import {
  createTenantAction, getOneMemberAction, getHasEmailAction, listTenantsAction, uploadAction, updateTenantAction,
  getTemplateSample2InfoAction,
} from '@ivymobi/orbit-core/business/tenant';
import {
  TenantContext, UserContext, LanuageContext, TeammessageContext, WebSiteContext, DeviceType
} from './orbit-context';
import {
  getRobotLocalesAction, getThirdTenantInfoAction, getUnitsInfoAction
} from '@ivymobi/orbit-core/business/productCenter';
import {
  getSampleInfo2ButtonAction,
} from '@ivymobi/orbit-core/business/tenant';
import { getCheckInfoAction } from '@ivymobi/orbit-core/business/user';


import SideBar from './layout/sidebar';
import Members from './members';
import Settings from './settings/settings';
import ConsoleDocuments from './documents/console';
import Dashboard from './dashboard/dashboard';
import ProductsManage from './products/productsManage';
import ArticalsManage from './products/articalsManage';
import ProductContainer from './productsnostate/productContainer';
import ProductDetailContainer from './productsnostate/productDetailView';

import Tracking from './tracking/user';
import Favorites from './favorites';
import CampainContainer from './campaign';
import MyContainer from './my/my';
import DocumentContainer from './documentnostate/documentContainer';
import ErrorBoundary from './components/errorBoundles';
import EmptyState from './components/emptyState';
import MyApplet from './applet/applet';
import ICatalog from './icatalog';
import ExternalDatabase from './applet/externalDatabase';

import AppBar from './layout/appbar';
import UserMenu from './layout/userMenu';
import Loader from './components/loaders';
import { isEmpty } from 'lodash';
import NavBar from './components/navbar/index.js'
import Selection from './selection';
import Solutions from './solutions';
import SolutionsList from './solutions/list';
import SolutionsPreviewDetail from './solutions/preview-detail';
import SolutionsPreview2DDetail from './solutions/preview2d-detail';

import FileDownloadContainer from './newmodules/filesDownload';
import ArticalViewContainer from './newmodules/artical';
import ShareUrl from './components/views/shareUrl';
import i18n from './services/i18n';

const Landing = lazy(
  () => import('./landing' /* webpackChunkName: "landing" */)
);

// 团队信息先写死
const tenant_info = {
  'info': {
    'logo': 'https://lite-cdn.yangbentong.com/36b2bdf8-249e-4221-86f3-38a5afc43e1b/398e4195-64a1-4b97-9db7-ffa9fd67713e.jpeg',
    'mail': 'cd@ivymobi.com',
    'phone': '',
    'status': 'verified',
    'address': '',
    'website': '',
    'nametemp': '德和盛电气 (上海) 有限公司'
  },
  'pimid': '36b2bdf8-249e-4221-86f3-38a5afc43e1b',
  'id': '36b2bdf8-249e-4221-86f3-38a5afc43e1b',
  'name': '德和盛电气 (上海) 有限公司',
  'createdAt': '2022-11-30T06:00:11.113Z',
  'status': 'active',
  'isCurrent': true,
  'ownerId': '989c88cd-c56d-4bd4-a370-9f50a16bedd0',
  'tntindex': 'other',
  'tntstatus': '已认证',
  'pcstauts': '已开通产品中心',
  'pcstautscode': true
};

// LOGO
const TenantLogo: FunctionComponent<{ srcUrl: string }> = ({ srcUrl }) => {
  console.log("srcUrl============",srcUrl)
  return (
    <MenuItem component={Link} to="/" style={{ paddingLeft: '32px', overflow: 'unset', backgroundColor: '#fff' }} >
      <ListItemIcon>

        <img src={srcUrl ?? ''} style={{ height: '47px', marginRight: '8px' }} />
      </ListItemIcon>
    </MenuItem>
  );
};

const useStyles = makeStyles((theme: Theme) => createStyles({
  appFrame: () => ({
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    // "@media (min-width: 768px)": {
    //   marginTop: theme.spacing(7),
    // },
    // "@media (max-width: 768px)": {
    //   marginTop: theme.spacing(0),
    // }
  }),
  consoleFrame: () => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginTop: theme.spacing(0)
  }),
  test: { height: '100%', width: '100%' }, // CacheRoute 标签会自动加一层没有样式的 div
  childMode: {
    fontSize: '15px',
    paddingLeft: '10px',
    paddingRight: '10px',
    whiteSpace: 'nowrap',
    // textOverflow:'ellipsis',
  },
  contentWithSidebar: {
    // width: '100%',
    // height: '100%',
    display: 'flex',
    flexGrow: 1
  },
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    // flexBasis: 0,
    background: theme.palette.grey[50],
    padding: theme.spacing(0)
  }
}));

export const AppRouters = (props: any) => {
  const { isConsole, setCheckTeam, setCheckEmail, rootDoc, rootArt, setTitle, setParents,doLogin,aclInfo } = props;
  const classes = useStyles();
  const dispatch = useDispatch()
  const deviceType = useContext(DeviceType);
  const [languageInfo, setLanguageInfo] = useState(null);  // 产品中心字典（PIM）

  // console.log('11------rootDoc === ', rootDoc);
  // console.log('22------rootArt === ', rootArt);
  const doGetLanguageInfo = useCallback(async() => {
    try {
      const params = {
        user: {
          token: null,
          user: null
        },
        tenant: { 
          id: tenant_info.id 
        },
        local: i18n.language==='zh-CN' ? 'zh' : i18n.language
      };
      const res = await dispatch(getRobotLocalesAction(params));
      console.log("res=============",res)
      setLanguageInfo(res);
      // setLoadStatus({...loadStatus, languageStatus: true, });
    } catch (err) {
      console.error('err', err);
    }
  }, [tenant_info, i18n]);
  useEffect(()=>{
    doGetLanguageInfo()
  },[])
  if(!languageInfo){
    return <Loader></Loader>
  }
  return (
    <main className={classes.contentWithSidebar} style={{
      height: deviceType === 'mobile' ? 'calc(100vh - 50px)' : 'calc(100vh - 60px)',
      marginTop: deviceType === 'mobile' ? '0' : '60px'
    }}>
      {isConsole && <SideBar />}
      <ErrorBoundary>
        <div className={classes.content}>
          <CacheSwitch>
            <Route exact path={['/settings']} >
              <MyContainer />
            </Route>
            <CacheRoute className={classes.test} exact path={['/products', '/products/:id', '/products/:id/:moduletype']} >
              <ProductContainer />
            </CacheRoute>
            <CacheRoute className={classes.test} exact path={['/productDetail/:id']}>
              <ProductDetailContainer lanuage={languageInfo}/>
            </CacheRoute>
            <Route exact path={['/documents', '/documents/:id']} >
              <DocumentContainer />
            </Route>
          
            <Route exact path='/solutions'>
              <Solutions />
            </Route>
            <Route exact path='/solutions/:id/list'>
              <SolutionsPreview2DDetail />
            </Route>
            <Route exact path='/solutions/:id'>
              <SolutionsList />
            </Route>
            <Route exact path='/solutions/previewDetail/:id'>
              <SolutionsPreviewDetail />
            </Route>

            <Route exact path={['/assets/:root/:id']} >
              <FileDownloadContainer aclInfo={aclInfo} doLogin={doLogin} setParents={setParents} setTitle={setTitle} />
            </Route>
            <Route exact path={['/articles/:id']} >
              <ArticalViewContainer setParents={setParents} setTitle={setTitle} />
            </Route>

            <Route exact path='/assets' >
              <Redirect to={`/assets/${rootDoc.cLinkId}/${rootDoc.cLinkId}?title=${rootDoc.cLinkName ?? rootDoc.cName}`} />
            </Route>
            <Route exact path='/articles' >
              <Redirect to={`/articles/${rootArt.cLinkId}?title=${rootArt.cLinkName ?? rootArt.cName}`} />
            </Route>

          </CacheSwitch>
        </div>
      </ErrorBoundary>
    </main>
  );
};

export const Container = (props: any) => {
  const { user, tenant, teamMessage, rootDoc, rootArt, setCheckTeam, setCheckEmail,doLogin,aclInfo } = props;
  const history = useHistory();
  const [t] = useTranslation();
  const { search } = location
  const paramsString = search.substring(1)
  const searchParams = new URLSearchParams(paramsString)  
  const classes = useStyles();
  const deviceType = useContext(DeviceType);
  const urlParams = new URL(window.location.href);
  const pathname = urlParams?.pathname;
  const isAdmin = tenant?.member?.groups.includes('00000000-0000-4000-8000-000000000000');
  const isConsole = pathname.indexOf('/console') !== -1;
  // console.log('app container tenant info = ', pathname, isAdmin, tenant, user)
  // console.log('------device type === ', deviceType);
  // console.log('------rootDoc === ', rootDoc);

  // 手机版导航参数
  const [parents, setParents] = useState([]); // 上级目录参数 eg.[{ to: '/robot', name: '机器人'}]
  const [title, setTitle] = useState(''); // 当前名称
  const [show,setShow] = useState(false)
  // 根据当前路径获取当前目录名称
  const getCurrentTitle = () => {
    if (pathname.search('/products') !== -1 || pathname.search('/productDetail') !== -1) {
      setTitle('产品中心');
    } else if (pathname.search('/solutions') !== -1) {
      setTitle('解决方案');
    } else if (pathname.search('/assets') !== -1) {
      setTitle('资料中心');
    } else if (pathname.search('/articles') !== -1) {
      setTitle('企业信息');
    }
  };

  useEffect(() => {
    getCurrentTitle();
  }, [pathname]);

  if (pathname === '/') {
    return (
      <UserContext.Provider value={user}>
        <TenantContext.Provider value={tenant}>
          <div className={classes.appFrame}>
            <Landing />
            <AppBar>
              <TenantLogo srcUrl={tenant?.info?.logo} />
              {/* <div style={{ flex: 1 }} />
              {(!isEmpty(user)) && isAdmin && <Switch>
                <Route path='/console'>
                  <MuiLink component={Link} to='/' color="textSecondary">
                    {t('common.web')}
                  </MuiLink>
                </Route>
                <Route>
                  <MuiLink component={Link} to='/console' color="textSecondary">
                    {t('common.console')}
                  </MuiLink>
                </Route>
              </Switch>}
              
              {(isEmpty(user))&&(window.self===window.top&& window.WeixinJSBridge==undefined)&&deviceType === 'desktop'&& <MuiLink component={Link} to='/user' color="textSecondary" style={{ display: 'flex', alignItems: 'center', fontSize: '16px' }} className={classes.childMode}>
                <div style={{ paddingLeft: '5px', color: 'black' }}>登录</div>
              </MuiLink>}
              {(!isEmpty(user)) && <UserMenu logout={props.logout} />} */}
            </AppBar>
          </div>
        </TenantContext.Provider>
      </UserContext.Provider>
    );
  } else {
    console.log("tenant==============",tenant)
    return (
      <UserContext.Provider value={user}>
        <TenantContext.Provider value={tenant}>
          <TeammessageContext.Provider value={teamMessage}>
            {!isConsole && <div className={classes.appFrame}>
              {deviceType === 'desktop' && <AppBar>
                <TenantLogo srcUrl={tenant?.info?.logo} />
                <Box style={{ flex: 1 }}>
                  <MuiLink 
                  underline='hover'
                    component={Link} 
                    to='/products' 
                    color={(pathname.search('/products') !== -1 || pathname.search('/productDetail') !== -1) ? 'error' : 'textSecondary'} 
                    className={classes.childMode}
                  >
                    产品中心
                  </MuiLink>
                  <MuiLink 
                  underline='hover'
                    component={Link} 
                    to='/solutions' 
                    color={(pathname.search('/solutions') !== -1) ? 'error' : 'textSecondary'} 
                    className={classes.childMode}
                  >
                    解决方案
                  </MuiLink>
                  <MuiLink 
                  underline='hover'
                    component={Link} 
                    to={'/assets'} 
                    color={(pathname.search('/documents') !== -1) ? 'error' : 'textSecondary'} 
                    className={classes.childMode}
                  >
                    资料中心
                  </MuiLink>
                  <MuiLink underline='hover' component={Link} to='#' color='textSecondary' className={classes.childMode} onClick={() => {
                    window.open('https://dcnpim.dehngroup.com.cn', '_blank')
                  }}>
                    智能选型 
                  </MuiLink>
                  {/* <MuiLink component={Link} to='#' color='textSecondary' className={classes.childMode} onClick={() => {
                    window.open('https://dehn.yangben.cn/selection', '_blank')
                  }}>
                    产品选型
                  </MuiLink> */}
                  <MuiLink 
                  underline='hover'
                    component={Link} 
                    to={'/articles'} 
                    color={(pathname.search('/articles') !== -1) ? 'error' : 'textSecondary'} 
                    className={classes.childMode}
                  >
                    企业信息
                  </MuiLink>
                </Box>
                <div onClick={()=>{
                  setShow(true)
                }} style={{ paddingLeft: '5px', color: 'black' ,paddingRight:'0px',cursor:'pointer',height:'48px'}}>
                  <img width={'48px'} height={'48px'}  style={{padding:'12px'}} src='/images/shares.png'></img>
                </div>
                {(isEmpty(user))&&(window.self===window.top&& window.WeixinJSBridge==undefined) && <MuiLink underline='hover' component={Link} to='/user' color="textSecondary" style={{ display: 'flex', alignItems: 'center', fontSize: '16px' }} className={classes.childMode}>
                  <div style={{ paddingLeft: '5px', color: 'black' }}>登录</div>
                </MuiLink>}
                {(!isEmpty(user)) && <UserMenu logout={props.logout} />}
              </AppBar>}
              {deviceType === 'mobile' && <NavBar
                user={null}
                onCustomClick={()=>{setShow(true)}}
                title={title}
                onShareClick={false}
                onCollectionClick={true}
                parents={[{ to: '/', name: '首页' }, ...parents]} 
              />}
              <AppRouters aclInfo={aclInfo} doLogin={doLogin} isConsole={isConsole} setCheckTeam={setCheckTeam} setCheckEmail={setCheckEmail} rootDoc={rootDoc} rootArt={rootArt} setTitle={setTitle} setParents={setParents} />
            </div>}
            {isConsole && <div className={classes.consoleFrame}>
              <AppRouters aclInfo={aclInfo} doLogin={doLogin} isConsole={isConsole} setCheckTeam={setCheckTeam} setCheckEmail={setCheckEmail} rootDoc={rootDoc} rootArt={rootArt} setTitle={setTitle} setParents={setParents} />
            </div>}
            <ShareUrl name={searchParams.get('title')??(pathname.search('/solutions') !== -1?'解决方案':'产品中心')} show={show} setShow={setShow}></ShareUrl>

          </TeammessageContext.Provider>
        </TenantContext.Provider>
      </UserContext.Provider>
    );
  }
};

const AppContainer = ({ login, logout, user, doLogin }) => {
  const dispatch = useDispatch();
  // const history = useHistory();
  const [tenant, setTenant] = useState(tenant_info)

  const [checkEmail, setCheckEmail] = useState(false);
  const [teamMessage, setTeamMessage] = useState({warning: false, warningMessage: ' '});
  const [checkTeam, setCheckTeam] = useState(false);

  const fetchMember = useCallback((switchTenant) => {
    return dispatch(getOneMemberAction({ user, tenant: switchTenant, payload: { id: user.user.id }})).then((member) => {
      setTenant({ ...switchTenant, member });
    });
  }, [dispatch, user]);

  useEffect(() => {
    dispatch(getThirdTenantInfoAction({tenantIndex:'Dehn'})).then(res => {
      setTenant({...res[0],id:res[0]?.tnt_id,info:res[0]?.tnt_info})
    })
  }, [dispatch]);

  useEffect(() => {
    if (tenant !== null) {
      dispatch(getHasEmailAction({ user, tenant})).then((res) => {
        // const { result } = res;
        setCheckEmail(true);
      });
    }
  }, [dispatch, tenant, checkEmail]);

  // 2.方法
  useEffect(() => {
    if (tenant !== null && !checkTeam) {
      dispatch(getCheckInfoAction({user, tenant})).then(([res]) => {
        const {opsinfo, opsinfocode, pgbinfo, pgbinfocode, flowinfo, flowinfocode} = res;
        if (opsinfocode === '0' && pgbinfocode === '0' && flowinfocode === '0') {
          setTeamMessage({warning: false, warningMessage: ' '});
          setCheckTeam(true);
        } else {
          const message = opsinfocode === '0' ? pgbinfocode === '0' ? flowinfocode === '0' ? '信息异常': flowinfo: pgbinfo: opsinfo;
          setTeamMessage({warning: true, warningMessage: message});
          setCheckTeam(true);
        }
      });
    }
  }, [dispatch, tenant, teamMessage, checkTeam]);

  const [rootDoc, setRootDoc] = useState(null);
  const [aclInfo, SetAclInfo] = useState({required:[],visitor_info:[],eoi:[]});
  const [rootArt, setRootArt] = useState(null);
  const [language, setLanguage] = useState('zh'); // 没有其他语言，先写死

  useEffect(() => {
    dispatch(getSampleInfo2ButtonAction({ tenant, language: language, user: { token: '' } })).then(res => {
      // console.log("getSampleInfo2ButtonActiongetSampleInfo2ButtonAction----res==", res);
      if (res && res.data && res.data.content) {
        const docInfos = _.filter(res.data.content, { language: language, cType: 'doc' });
        // console.log('doc info === ', docInfos)
        if (docInfos && docInfos[0] && docInfos[0].cLinkId) {
          setRootDoc(docInfos[0]??[]);
        }
        SetAclInfo({required:res.data?.required??[],visitor_info:res.data?.visitor_info??[],eoi:res.data?.eoi??[]})
        // SetAclInfo({required:res.data?.required??[],visitor_info:res.data?.visitor_info??[],eoi:res.data?.eoi??[]})

        const artInfos = _.filter(res.data.content, { language: language, cType: 'art' });
        if (artInfos && artInfos[0] && artInfos[0].cLinkId) {
          setRootArt(artInfos[0]??[]);
        }
      }      
    });
  }, [dispatch, tenant, language]);

  if (!rootArt || !rootDoc) {
    return <Landing />;
  }

  // console.log('root ======= ', rootDoc, rootArt);

  return (
    <Container 
      user={user}
      tenant={tenant}
      teamMessage={teamMessage}
      rootDoc={rootDoc}
      rootArt={rootArt}
      logout={logout}
      aclInfo={aclInfo}
      doLogin={doLogin}
      setCheckEmail={setCheckEmail} 
      setCheckTeam={setCheckTeam} 
    />
  )
}

export default AppContainer;